// extracted by mini-css-extract-plugin
export var cancelButton = "_pb-5";
export var content = "_pb-3";
export var createButton = "_pb-6";
export var drawerContainer = "_pb-0";
export var footer = "_pb-2";
export var header = "_pb-1";
export var orderFormColumn = "_pb-4";